export const makeLink = (url: string) => {
  const anchor = document.createElement('a');
  anchor.target = '_blank';
  anchor.href = url;
  return anchor;
};
